import React from "react";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { DPSpacer } from "Components/DP";
import TopNavMenu from "../TopNavMenu/TopNavMenu";
import ProviderIcon from "./ProviderIcon";
import ProviderSelectMenuItem from "./ProviderSelectMenuItem";

const ProviderSelect = () => {
  const { currentProvider, providers } = usePartnerConfig();
  if (!currentProvider || !providers) {
    return null;
  }
  const menuItems = providers.map(provider => (
    <ProviderSelectMenuItem key={provider.id} provider={provider} />
  ));
  return (
    <TopNavMenu
      disabled={menuItems.length <= 1}
      menuItems={menuItems}
      menuName="providerSelect"
    >
      <ProviderIcon icon={currentProvider.icon || ""} />
      <DPSpacer />
      {currentProvider.name}
    </TopNavMenu>
  );
};

export default ProviderSelect;
